
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.4 5.053V2.526H9.6v2.527h4.8zm-12 2.526v13.895h19.2V7.579H2.4zm19.2-2.526c1.332 0 2.4 1.124 2.4 2.526v13.895C24 22.876 22.932 24 21.6 24H2.4C1.068 24 0 22.876 0 21.474L.012 7.579c0-1.402 1.056-2.526 2.388-2.526h4.8V2.526C7.2 1.124 8.268 0 9.6 0h4.8c1.332 0 2.4 1.124 2.4 2.526v2.527h4.8z","fill":"#282828"}})])
          )
        }
      }
    